import { render, staticRenderFns } from "./OnboardingDocuments.vue?vue&type=template&id=79625b20"
import script from "./OnboardingDocuments.vue?vue&type=script&lang=js"
export * from "./OnboardingDocuments.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDocuments.vue?vue&type=style&index=0&id=79625b20&prod&lang=scss&style=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports